import React, { FC } from "react";
import { GuildTabType } from ".";
import classNames from "classnames";
import { useSearchParams } from "react-router-dom";
import { useAppTranslation } from "../../i18n/useAppTranslation";

type Props = {
  tabs: GuildTabType[];
  value: string;
};

const GuildTabs: FC<Props> = ({ tabs, value }) => {
  const { t } = useAppTranslation("guild");
  const [searchParameters, setSearchParameters] = useSearchParams();
  // Switching tab is in-page view state, not a navigation step. Pushing it made
  // every tab the user touched another entry the back button had to walk out
  // through before it could leave the guild page at all.
  const changeQuery = (val: number | string | boolean, name: string) => {
    val ? searchParameters.set(name, val + "") : searchParameters.delete(name);
    setSearchParameters(searchParameters, { replace: true });
  };

  return (
    <div className="gh-tabs" role="tablist" aria-label={t("guild:tabsAria")}>
      {tabs.map((tab) => {
        if (tab.hidden) return null;
        const isActive = value === tab.value;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            disabled={tab.disabled}
            onClick={() => changeQuery(tab.value, "tab")}
            className={classNames("gh-tab", { "is-active": isActive })}
          >
            <img src={tab.icon} alt="" />
            {tab.title}
          </button>
        );
      })}
    </div>
  );
};

export default GuildTabs;
